import {
  DoneAll,
  HorizontalRule,
  LooksOne,
  LooksTwo,
  Pending,
} from "@mui/icons-material";
import { ChipProps } from "@mui/material";
import {
  SystemFieldProofreadingStatus,
  SystemEntityProofreadingStatus,
} from "../../../../shared/enums/shared-enums";

export const fieldStatusConfigs: Record<
  SystemFieldProofreadingStatus,
  ChipProps
> = {
  no_proofreading: {
    icon: <HorizontalRule />,
    label: "No Proofreading",
    color: "grey",
  },
  needs_work: {
    icon: <Pending />,
    label: "Needs more work",
    color: "red",
  },
  proofread_once: {
    icon: <LooksOne />,
    label: "Proofread once",
    color: "orange",
  },
  proofread_twice: {
    icon: <LooksTwo />,
    label: "Proofread twice",
    color: "yellow",
  },
  approved: {
    icon: <DoneAll />,
    label: "Approved",
    color: "green",
  },
};

export const entityStatusConfigs: Record<
  SystemEntityProofreadingStatus,
  ChipProps
> = {

    [SystemEntityProofreadingStatus.NOT_PROOFREAD]: {
    icon: <HorizontalRule />,
    label: "Not proofread",
    color: "grey",
  },
  [SystemEntityProofreadingStatus.PARTLY_PROOFREAD]: {
    icon: <LooksOne />,
    label: "Partly proofread",
    color: "orange",
  },
    [SystemEntityProofreadingStatus.UNPUBLISHED]: {
    icon: <LooksTwo />,
    label: "Unpublished",
    color: "yellow",
  },

  [SystemEntityProofreadingStatus.PUBLISHED]: {
    icon: <DoneAll />,
    label: "Published",
    color: "green",
  },



};
